import { render, staticRenderFns } from "./bestWorks.vue?vue&type=template&id=68f8f3a7&"
import script from "./bestWorks.vue?vue&type=script&lang=js&"
export * from "./bestWorks.vue?vue&type=script&lang=js&"
import style0 from "./bestWorks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports